import Layout from '@/layout';
var newDistributionRouter = {
  path: '/newDistribution',
  component: Layout,
  redirect: '/newDistribution/brand/index',
  name: 'newDistribution',
  meta: {
    title: '分销管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'brand',
    component: function component() {
      return import('@/views/newDistribution/brand/index');
    },
    name: 'Brand',
    meta: {
      title: '品牌管理',
      icon: ''
    }
  }, {
    path: 'rewardConfig',
    component: function component() {
      return import('@/views/newDistribution/rewardConfig/index');
    },
    name: 'RewardConfig',
    meta: {
      title: '奖励比例管理',
      icon: ''
    }
  }, {
    path: 'distributionStaff',
    component: function component() {
      return import('@/views/newDistribution/distributionStaff/index');
    },
    name: 'DistributionStaff',
    meta: {
      title: '分销员工管理',
      icon: ''
    }
  }, {
    path: 'customerLevel',
    component: function component() {
      return import('@/views/newDistribution/customerLevel/index');
    },
    name: 'CustomerLevel',
    meta: {
      title: '客户层级管理',
      icon: ''
    }
  }, {
    path: 'vmUser',
    component: function component() {
      return import('@/views/newDistribution/vmUser/index');
    },
    name: 'Brand',
    meta: {
      title: '客户清单',
      icon: ''
    }
  }]
};
export default newDistributionRouter;